import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { columnGroupingModel, columns, getRowId, tableStyles } from './utils';

export default function LeadTimesTable({ rows }) {
	return (
		<Box>
			<DataGridPro
				rows={rows}
				getRowId={getRowId}
				columns={columns}
				columnGroupingModel={columnGroupingModel}
				getDetailPanelHeight={() => 'auto'}
				disableColumnMenu
				disableRowSelectionOnClick
				sx={tableStyles}
			/>
		</Box>
	);
}
